export default __webpack_public_path__ + "static/media/Platforms.790d6497.svg";